<template>
    <div class="step_modal">
        <div class="steps_popup">
            <div class="steps_close"><div @click="closePopup"><SvgHeaderSvg :type="'close'" class="largesvg"/></div></div>
            <div v-if="data" class="steps_data">
                <div class="image text-center mb-3">
                    <img width="200" height="200" :src="data.product.image" alt="">
                </div>
                <div class="text">
                    <h4 class="font-active text-center">{{ data.product.name }}</h4>
                    <h5 class="text-center">{{ data.product.price }}</h5>
                </div>
                <div class="ctas">
                    <div class="cta_btn" @click="changeProduct(data.product.page)">change</div>
                    <div class="cta_btn" @click="productUrl(data.product.page)">details</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    const { data } = defineProps(['data'])
    const emits = defineEmits(['closePopup', 'changeProduct', 'productUrl'])

    function closePopup(){
        emits('closePopup')
    }

    function changeProduct(type){
        emits('changeProduct', type)
    }

    function productUrl(type){
        emits('productUrl', type)
    }

</script>

<style scoped>

img {
    border-radius: 8px;
}

.largesvg {
    transform: scale(1.3);
}
.step_modal {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 -2px 10px 0 rgba(0, 0, 0, 0.15);
    padding: 13px;
    border-radius: 8px 8px 0 0;
    background: #fff;
    z-index: 999;
    /* min-height: 300px; */
}
h4 {
    font-size: 18px;
    color: #212529;
}

h5 {
    font-size: 18px;
    color: var(--green);
    font-weight: 600;
    padding: 10px 0;
}

.ctas {
    display: flex;
    align-items: center;
    justify-content: center;
}

.cta_btn {
    border: 1px solid var(--green);
    min-width: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    color: var(--green);
    text-transform: uppercase;
    font-size: 14px;
    margin: 0 5px;
    height: 40px;
    font-weight: 600;
}

.steps_close {
    text-align: right;
    margin-bottom: 5px;
}
</style>
